<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="line_item_tooltip_name" :name="line_item_tooltip_name" :description="line_item_tooltip_description" :editable="editable"></tool-tip>
    <div v-if="!isPartnerAccount">
      <line-item-modal
        :is-read-only="isReadOnly"
        :show-line-item-modal="showLineItemModal"
        :id="lineItemId"
        :is-new="isNew"
        v-on:modal-closed="clearModalData"
      >
        <template v-slot:modal-link > Add </template>
      </line-item-modal>
      <line-item-reorder-enable :is-read-only="isReadOnly" v-if="!isReorderable"></line-item-reorder-enable>
     <line-item-reorder :is-read-only="isReadOnly" v-else></line-item-reorder>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <el-table
          :data="lineItems"
          :summary-method="summary"
          show-summary
          :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
        >
          <el-table-column
            v-if="!isPartnerAccount"
            :min-width="140"
            align="left"
            label="Actions"
          >
            <div slot-scope="props" class="table-actions">
              <el-tooltip
                content="Delete Line Item"
                :open-delay="300"
                effect="light"
                placement="top"
              >
                <a
                  @click.prevent
                  v-if="isReadOnly"
                  href="#"
                  class="btn-link btn-danger btn-disabled"
                  :disabled="deleteDisabled"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                </a>
                <a
                  v-else
                  href="##"
                  @click.prevent="
                    deleteLineItem(
                      props.row.lineItemId,
                      props.row.stockSubClassName,
                      props.row.itemNumber
                    )
                  "
                  class="btn-link btn-danger"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                </a>
              </el-tooltip>
              <el-tooltip
                content="Edit Line Item"
                :open-delay="300"
                effect="light"
                placement="top"
              >
                <base-button
                  :disabled="isReadOnly || isPartnerAccount"
                  class="btn btn-icon btn-fab btn-default btn-sm btn-link"
                  @click.native="viewItem(props.row.lineItemId)"
                >
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
              </el-tooltip>
            </div>
          </el-table-column>

          <el-table-column
            v-for="column in tableColumns"
            sortable
            :key="column.label"
            :min-width="column.minWidth"
            :formatter="column.formatter"
            :prop="column.prop"
            :label="column.label"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BaseSwitch, BaseButton, Modal } from "@/components";
import LineItemModal from "@/components/App/order/submission/lineitem/LineItemModal.vue";
import LineItemReorderEnable from "@/components/App/order/submission/lineitem/LineItemReorderEnable.vue";
import LineItemReorder from "@/components/App/order/submission/lineitem/LineItemReorder.vue";
import Util from "../../../../../util/util";
import swal from "sweetalert2";
import  toolTip  from "../../../Tooltip";


export default {
  props: ["isReadOnly"],
  name: "line-item",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    Modal,
    LineItemModal,
    LineItemReorderEnable,
    LineItemReorder,
    toolTip
  },
  data() {
    return {
      showLineItemModal: false,
      isNew: true,
      deleteDisabled: false,
      lineItemId: 0,
      renderKey: 0,
      line_item_tooltip_name: '',
      line_item_tooltip_description:'',
      tableColumns: [
        {
          prop: "itemNumber",
          label: "Item No",
          minWidth: 180,
        },
        // {
        //   prop: "fundCitationName",
        //   label: "Fund Citation",
        //   minWidth: 180,
        // },
        {
          prop: "stockClassName",
          label: "Class of Supply",
          minWidth: 180,
        },
        {
          prop: "stockSubClassName",
          label: "Sub Class",
          minWidth: 180,
        },
        {
          prop: "stockDescription",
          label: "stock No & Description",
          minWidth: 230,
        },
        {
          prop: "unitMeasure",
          label: "Unit Of Measure",
          minWidth: 210,
        },
        {
          prop: "requestedQuantity",
          label: "Request Qty",
          minWidth: 180,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.requestedQuantity);
          },
        },
        {
          prop: "unitPrice",
          label: "Unit Price",
          minWidth: 180,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.unitPrice);
          },
        },
        {
          prop: "partnerItemTotal",
          label: "Partner Total",
          minWidth: 180,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.partnerItemTotal);
          },
        },
        {
          prop: "usItemTotal",
          label: "US Total($)",
          minWidth: 180,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.usItemTotal);
          },
        },
      ],
    };
  },
  async mounted() {
   await this.getAllTooltips()
   this.loadToolTips()
 },
  beforeMount() {
    this.deleteDisabled = true;
  },
  watch: {
    "lineItem.stockClassId": function (newValue, oldValue) {
      if (newValue) {
        this.getStockSubClasses(newValue);
      }
    },
  },
  computed: {
    ...mapGetters({
      lineItem: "lineItem/lineItem",
      lineItems: "lineItem/lineItems",
      stockClasses: "stockClass/stockClasses",
      stockSubClasses: "stockClass/stockSubClasses",
      unitMeasures: "unitMeasure/unitMeasures",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isReorderable() {
      return this.lineItems.every((i) => !isNaN(i.itemNumber));
    },
  },
  methods: {
    ...mapActions({
      getLineItems: "lineItem/getLineItems",
      getLineItem: "lineItem/getLineItem",
      getLineItemStatus: "lineItem/getLineItemStatus",
      removeLineItem: "lineItem/removeLineItem",
      getOrderByStatus: "orders/getOrderByStatus",
      getUnitMeasures: "unitMeasure/getUnitMeasures",
      getStockClasses: "stockClass/getStockClasses",
      getStockSubClasses: "stockClass/getStockSubClasses",
      saveLineItem: "lineItem/saveLineItem",
      clearStockSubClass: "lineItem/clearStockSubClass",
      updateLineItems: "lineItem/updateLineItems",
      getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const lineItemToolTip = this.toolTips.find(e => e.name === "LineItemModule")
    if(lineItemToolTip.status){
      this.line_item_tooltip_description = lineItemToolTip.description ? lineItemToolTip.description :  null
      this.line_item_tooltip_name = lineItemToolTip.name ? lineItemToolTip.name :  null

    }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    loaded() {
      this.getLineItems(this.$route.params.id);
    },
    viewItem(lineItemId) {
      let ctx = this;
      ctx.getUnitMeasures();
      ctx.getStockClasses();
      ctx.getLineItem(lineItemId).then(() => {
        this.errors.clear();
        this.lineItemId = lineItemId;
        this.showLineItemModal = true;
        this.isNew = false;
      });
    },
    // Clearing Modal data after the modal is closed.
    clearModalData() {
      this.errors.clear();
      this.lineItemId = 0;
      this.showLineItemModal = false;
      
      this.isNew = true;
    },
    generateTotal(values) {
      if (!values.every((value) => isNaN(value))) {
        return values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      } else {
        return null;
      }
    },
    stockClassOnChange(value) {
      this.clearStockSubClass();
      this.getStockSubClasses(value);
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
    // Returns updated lineItems with itemNumbers after removing the deleted line item.
    updateLineItemNumbers(lineItemId) {
      let updatedLineItems = this.lineItems
        .filter((lineItem) => lineItem.lineItemId !== lineItemId)
        .map((lineItem, index) => {
          return { lineItemId: lineItem.lineItemId, itemNumber: index + 1 };
        });
      return updatedLineItems;
    },
    deleteLineItem(lineItemId, stockSubClassName, itemNumber) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete line item #${itemNumber}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete line item #${itemNumber}!`,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let ctx = this;
          let lineItemsCount = ctx.lineItems.length;
          ctx.removeLineItem(lineItemId).then((response) => {
            if (lineItemsCount > 1) {
              ctx
                .updateLineItems(ctx.updateLineItemNumbers(lineItemId))
                .then(() => {
                  ctx.getLineItems(ctx.$route.params.id);
                });
            } else {
              ctx.getLineItems(ctx.$route.params.id);
            }
            ctx.getOrderByStatus({
              orderStatus: ctx.orderMetadata.orderStatus,
              id: ctx.$route.params.id,
            });
            new swal({
              title: "Confirmation of Delete",
              text: "Line item has been deleted successfully.",
              icon: "success",
              confirmButtonColor: "#10b45a",
            });
          });
        }
      });
    },
    setItemNumber() {
      let ctx = this;
      //if its  new genrate new item number
      // otherwise get the current postion
      // the add 1 to convert from an index value to an acual number that makes sense to user
      if (ctx.isNew) {
        ctx.lineItem.itemNumber =
          Math.max.apply(
            Math,
            ctx.lineItems.map((lineItem) => lineItem.itemNumber)
          ) + 1;
      }
    },
    submit(e) {
      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx.setItemNumber();
          ctx.saveLineItem(ctx.$route.params.id).then((response) => {
            ctx.getLineItems(ctx.$route.params.id);
            ctx.getLineItemStatus(ctx.$route.params.id);
            ctx.getOrderByStatus({
              orderStatus: ctx.orderMetadata.orderStatus,
              id: ctx.$route.params.id,
            });
            ctx.modals.classic = false;
          });
        }
      });
    },
    closeForm() {
      this.modals.classic = false;
      this.errors.clear();
    },
    summary(param) {
      const { columns, data } = param;
      const sums = [];
      const totalColumns = ["usItemTotal"];
      const quantityColumns = [
        "requestedQuantity",
        "receivedQuantity",
        "unitPrice",
        "partnerItemTotal",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totals";
          return;
        }

        if (quantityColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);

          sums[index] = total
            ? Util.inMoneyFormatWithoutDollarSign(total)
            : "0.00";
          if (column.property == "requestedQuantity") {
            sums[index] = total
              ? Util.inMoneyFormatWithoutDollarSign(total)
              : "0.00";
          }
        } else if (totalColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
            : "$ 0.00";
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
  },
};
</script>